import { TableCellProps } from '@mui/material/TableCell';
import React from 'react';

import { StyledTableCell } from './tableCell.styles';

export const TableCell = (props: TableCellProps) => {
  return <StyledTableCell {...props} />;
};
